module.exports = __webpack_public_path__ + "img/80.9caea112.png";